/*
 * @Author: lyx
 * @Date: 2024-08-13 10:25:17
 * @LastEditors: lyx
 * @LastEditTime: 2024-08-13 11:14:04
 * @FilePath: /dbrank_b/src/routes/visualChart/P29/form.js
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseStringToArray, parseArrayToChart  } from '../utils';
import classnames from 'classnames';
import { chunk, drop ,dropRight} from 'lodash';
import { getVisual } from '../../../controller';

const defaultColorValue = '#f4cc00\n#00b050\n#0070c0\n#ff0000\n#adafb4\n#7030a0\n#b97966\n#fdeada\n#000';

class DataItem {
  title = '';
  list = [];
  constructor(title) {
    this.title = title;
  }
}

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      chartList: [],
      brandList: [],
      chartColorList: [],
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual(29).then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);
  
      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    
    const { columns, list } = parseArrayToChart(dataset, {});
    console.log(columns);
    return {
      chartList: columns,
      brandList: list
    }
  }


  static parseColor = (str) => {
    const chartColorList = parseStringToArray(str);

    return {
      chartColorList: chartColorList.map(([val]) => val)
    }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value, this.state.tableColorList);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const _color = Form.parseColor(value);

    this.setState({
      colorValue: value,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关，红色：#ff0000）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P29/Form.js